import React from "react";
import {component_tool} from '@/tool'
import {WizTableForm} from "../../../common";

let {WizDataTable, WizButton, WizPopover} = component_tool
const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})

export const columns1 = (self, info, surveyInfo) => {
  let columns = []
  columns = columns.concat([
    {
      title: 'surveyId',
      name: 'surveyId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: '问卷提交时间',
      name: 'submissionDate',
      tableItem: {}
    }
  ])
  let leng = 0
  let questions = []
  if (info.success) {
    let data = info.data
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        let iLen = data[i]['questions'].length
        for (let j = 0; j < data.length - i; j++) {
          let jLen = data[j]['questions'].length
          if (jLen > iLen) {
            leng = jLen
          } else {
            leng = iLen
          }
        }
      }
      data.forEach(e => {
        if (e['questions'] && e['questions'].length && e['questions'].length === leng) {
          questions = e['questions']
        }
      })
    }
  }
  if (questions && questions.length === 0 && surveyInfo.success) {
    let data = surveyInfo.data
    questions = data && data.questions
  }
  if (questions && questions.length) {
    let golbal_width = window.innerWidth / 2.4;
    let width = golbal_width / questions.length
    questions.forEach(e => {
      columns.push({
        title: e['title'],
        name: e['title'],
        tableItem: {
          width: width + e['title'].length * 10
        }
      })
    })
  }
  columns.push(
    {
      title: '操作',
      tableItem: {
        fixed: 'right',
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="查看" onClick={e => self._onLook(record, e)}>
              查看
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  )
  return columns
}

export const columns2 = () => [
  {
    title: 'id',
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '选项',
    name: 'selectItem',
    tableItem: {
      width:400
    }
  },
  {
    title: '选择次数',
    name: 'selectNum',
    tableItem: {}
  },
  {
    title: '比例（%）',
    name: 'proportion',
    tableItem: {}
  },
]
